<template>
	<div class="ui-progress-bar"
		:style="{
			'border-radius': borderRadius,
			'background': progressBarBgColor
		}"
	>
		<div v-if="showStatus" class="ui-progress-bar__progress-status">
			<span v-if="succesCollect" class="progress-status__success">
				Средства собраны
			</span>
			<span v-else class="progress-status__unsuccess">
				Средства не собраны
			</span>
		</div>
		<div
			class="ui-progress-bar__progress"
			:style="{
				'background': progressBarColor,
				'width': calculatedPercent + '%',
				'height': thickness + 'px',
				'border-radius': borderRadius
			}"
		/>
	</div>
</template>

<script>
import {mapGetters} from "vuex";
import modeTypeMixin from "@/mixins/modeTypeMixin";

export default {
	name: 'UiProgressBar',
	mixins: [modeTypeMixin],
	props: {
		showStatus: {
			type: Boolean,
			default: false
		},
		succesCollect: {
			type: Boolean,
		},
		isPublished: {
			type: Boolean,
		},
		collected: {
			type: Number,
		},
		maxTarget: {
			type: Number,
		},
		minTarget: {
			type: Number,
		},
		color: {
			type: String,
			default: 'var(--additional-3)'
		},
		thickness: {
			type: Number,
			required: true
		},
		borderRadius: {
			type: String,
			default: '30px'
		}
	},
	computed: {
		...mapGetters({
			project: 'project/getProject',
			isOwner: "project/getterIsOwner",
		}),
		calculatedPercent() {
			return (this.collected / this.maxTarget) * 100
		},
		progressBarColor() {
			if (this.collected < this.minTarget) {
				return '#FFBB00'
			}

			return '#158316';
		},
		progressBarBgColor() {
			if (this.collected > this.minTarget) {
				return '#48B349'
			}

			return 'var(--grey)';
		},
	},
}
</script>
